/**
 * Serializes PSI parameters to URLSearchParams.
 * Array values are encoded with PHP-style bracket notation (key[]=val1&key[]=val2)
 * so the PSI backend receives them as proper arrays.
 */
export function serializePsiParams(params: Record<string, string | string[]>): URLSearchParams {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      for (const item of value) {
        searchParams.append(`${key}[]`, item);
      }
    } else {
      searchParams.append(key, value);
    }
  }

  return searchParams;
}
